



























import { Component, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class'
import gameInterface from '@/game/places/map.ts';
import { User, SocketState, World } from '@/types';
import Shop from '@/components/Shop.vue';
import ActivityIndicator from '@/components/ActivityIndicator.vue';

@Component({
  components: { ActivityIndicator, Shop }
})
export default class Map extends Vue {
  @State public user!: User;
  @State public socket!: SocketState;
  @State public world!: World;
  @Mutation public SET_HEADER_VISIBILITY: any;

  public gameInterface = gameInterface();
  public mounted() {
    if (!this.socket.connected || !this.user.authenticated) {
      return this.$router.push({ name: 'world' });
    }
    this.SET_HEADER_VISIBILITY(false);
    this.gameInterface.launch();
  }
  public destroyed() {
    this.SET_HEADER_VISIBILITY(true);
    this.gameInterface.destroyGame();
  }
}
